import { FaBookOpen, FaBrain, FaDollarSign } from "react-icons/fa";
import { FiZap } from "react-icons/fi";
import Button from "../../components/EmptyButton";
import { apiRequest } from "../../helpers";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";

const TOKENS_PER_MILLION = 1000000;
const CREDITS_PER_MILLION_TOKENS = 19.11;

export default function Credits() {
  const navigate = useHistory();

  const [user, setUser] = useState(JSON.parse(sessionStorage.getItem('app_user')))

  const displayCredits = Math.round(
    ((Number(user?.total_tokens) || 0) / TOKENS_PER_MILLION) *
      CREDITS_PER_MILLION_TOKENS
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("token_checkout_session_id");

    if (!sessionId) {
      return;
    }

    apiRequest({
      method: "post",
      url: "accounts/packages/checkout/complete/",
      data: {
        session_id: sessionId,
      },
    })
      .then(() => {
        return apiRequest({
          method: "get",
          url: "accounts/users/user-info/",
        });
      })
      .then((res) => {
        sessionStorage.setItem("app_user", JSON.stringify(res.data));
        setUser(res.data);
        navigate.replace("/aitutor/creditsbot");
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  const features = [
    {
      icon: FaBrain,
      title: "Personalized Learning",
      description:
        "AI is trained with high quality academic resources to give accurate responses and adapts to your learning style, pace, and course materials for maximum effectiveness.",
    },
    {
      icon: FiZap,
      title: "Instant Feedback",
      description:
        "Get immediate explanations in simple words and corrections based on your uploaded course content.",
    },
    {
      icon: FaBookOpen,
      title: "Course-Specific Content",
      description:
        "Upload your course materials and lecture notes for tutoring tailored to your specific curriculum.",
    },
    {
      icon: FaDollarSign,
      title: "Simple Pricing",
      description:
        "Subscriptions are flexible. It can be upgraded or canceled anytime.",
    },
  ];

  const handleBuyCredits = () => {
    navigate.push("/aitutor/subscriptions");
  };

  const handleStartLearning = () => {
    navigate.push("/aitutor");
  };

  return (
    <div className="min-h-screen bg-warm-bg font-inter">
      {/* Header Badge */}
      <div className="flex justify-center pt-12">
        <div className="bg-primary/10 text-primary border border-primary/20 px-6 py-2 rounded-full text-sm font-semibold">
          🧠 AI-Powered Learning
        </div>
      </div>

      {/* Hero Section */}
      <div className="text-center py-20 px-6">
        <h1 className="text-4xl lg:text-6xl font-bold text-foreground leading-tight text-center">
          <span
            className="text-primary"
            style={{ fontSize: "3.75rem", fontWeight: "700" }}
          >
            Your Personal
          </span>
          <span
            className="text-foreground ml-2"
            style={{ fontSize: "3.75rem", fontWeight: "700" }}
          >
            AI Tutor
          </span>
        </h1>

        <p
          style={{ color: "#78726d" }}
          className="text-xl text-muted-foreground leading-relaxed"
        >
          Get personalized tutoring, instant feedback, and adaptive learning
          experiences. Upload your course materials and purchase credits to
          unlock unlimited learning potential.
        </p>

        {/* Credits Display */}
        <div className="mb-12 mt-24">
          <p style={{fontSize: '20px', color: '#78726d'}} className=" text-gray-600 mb-2 font-bold">
            Your Credits:
          </p>
          <div className="font-bold text-primary mb-8" style={{ fontSize: "3.75rem", fontWeight: "700" }}>{displayCredits}</div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="" style={{ width: "250px" }}>
                <Button onClick={handleBuyCredits} filled={true} className="text-lg px-4 w-24">
                  Get Credits
                </Button>
              </div>
              <div className="" style={{ width: "250px" }}>
                <Button
                  onClick={handleStartLearning}
                  className="text-lg px-8"
                  
                >
                  Start Learning
                </Button>
              </div>
            </div>
        </div>
      </div>

      {/* Features Grid */}
      <div className="max-w-7xl mx-auto px-6 pb-20">
        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-10 bg-white border-0 shadow-lg rounded-2xl hover:shadow-xl transition-all duration-200"
            >
              <div className="flex items-start gap-0">
              <div className="w-48 h-48 bg-gradient-hero rounded-lg flex justify-left group-hover:scale-110 transition-transform duration-300">
                  <feature.icon
                    className="text-primary-foreground text-primary"
                    style={{ fontSize: "3rem" }}
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4 text-gray-800">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed whitespace-pre-line text-lg">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
